import React from 'react';
import { Template } from 'components/Template';
import { LandingScreen } from './components/LandingScreen';
import Auth0ProviderWithHistory from 'components/Auth/Auth0ProviderWithHistory';
import { PrivacyPolicy } from 'components/PolicyPages/PrivacyPolicy/PrivacyPolicy';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { FAQs } from 'components/PolicyPages/FAQs/FAQs';
import { TermsandConditions } from 'components/PolicyPages/T&C/T&C';

const App: React.FC = () => {
  return (
    <Auth0ProviderWithHistory>
      <Template>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingScreen />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/FAQs" element={<FAQs />} />
          <Route path="/TermsandConditions" element={<TermsandConditions />} />
        </Routes>
        </BrowserRouter>
      </Template>
    </Auth0ProviderWithHistory>
  );
};

export default App;
